module.exports = __webpack_public_path__ + "static/img/godwealth2_esp.d12f6df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lucas/godwealth2_esp.png
// module id = ClT9
// module chunks = 1